/**
 * Stable CSS class names for E2E — Hidden Excel tables.
 */
export const HEX = {
    page: 'hidden-excel-page',
    loadingSection: 'hidden-excel-page__loading-section',
    breadcrumbSection: 'hidden-excel-page__breadcrumb-section',
    contentSection: 'hidden-excel-page__content-section',

    toolbarWrap: 'hidden-excel-page__toolbar',
    inputButtonAddTable: 'hidden-excel-page-input--button-add-table',
    gridWrap: 'hidden-excel-page__grid-wrap',

    inputIconViewFields: 'hidden-excel-page-input--icon-view-fields',
    actionsCellWrap: 'hidden-excel-page-datagrid-actions-cell',
    inputIconEditRow: 'hidden-excel-page-input--icon-edit-row',
    inputIconDeleteRow: 'hidden-excel-page-input--icon-delete-row',

    fieldListDialogPaper: 'hidden-excel-field-list-dialog',
    fieldListDialogTitleBar: 'hidden-excel-field-list-dialog__title-bar',
    inputIconCloseFieldListDialog: 'hidden-excel-field-list-dialog-input--icon-close',
    fieldListDialogChipsWrap: 'hidden-excel-field-list-dialog__chips-wrap',
    fieldListChip: 'hidden-excel-field-list-dialog__chip',

    drawerPaper: 'hidden-excel-drawer',
    drawerContent: 'hidden-excel-drawer__content',
    drawerHeader: 'hidden-excel-drawer__header',
    inputIconDrawerClose: 'hidden-excel-drawer-input--icon-close',
    drawerScrollBody: 'hidden-excel-drawer__body',
    inputTextTableName: 'hidden-excel-drawer-input--text-table-name',
    drawerFieldsSection: 'hidden-excel-drawer__fields-section',
    drawerFieldsSectionTitle: 'hidden-excel-drawer__fields-section-title',
    drawerAddFieldRow: 'hidden-excel-drawer__add-field-row',
    inputTextFieldName: 'hidden-excel-drawer-input--text-field-name',
    inputButtonAddField: 'hidden-excel-drawer-input--button-add-field',
    drawerFieldChipsWrap: 'hidden-excel-drawer__field-chips',
    drawerFieldChip: 'hidden-excel-drawer__field-chip',
    drawerFooter: 'hidden-excel-drawer__footer',
    inputButtonDrawerCancel: 'hidden-excel-drawer-input--button-cancel',
    inputButtonDrawerSubmit: 'hidden-excel-drawer-input--button-submit',
} as const;

export const hexCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
